var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-unknown"},[_vm._v("[未知类型消息]")])
}
var staticRenderFns = []

export { render, staticRenderFns }